<template>
  <v-card color="grey lighten-4 mb-2">
    <v-card-text class="white pa-0">
      <div class="grid-container">
        <table v-if="group_of_columns">
          <thead>
            <tr class="group-row">
              <th
                v-for="group in group_names"
                :key="group"
                :colspan="group_of_columns[group].length"
                :class="getClassGroupRowTh(group)"
              >
                <template v-if="group">
                  <div
                    class="column-group grey lighten-2 black--text caption py-1"
                  >
                    <v-tooltip
                      bottom
                      v-if="group_of_columns[group].length === 1"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="black" small>
                          {{ configStrategyTable[group].icon }}
                        </v-icon>
                      </template>
                      <span>{{ $t(group) }}</span>
                    </v-tooltip>
                    <template v-else>
                      <div
                        class="d-flex justify-center align-center"
                        style="gap: 5px"
                      >
                        <v-icon color="black" size="14">
                          {{ configStrategyTable[group].icon }}
                        </v-icon>
                        <span>
                          <template
                            v-if="
                              group.includes('pickup_') && group !== 'pickup_0'
                            "
                          >
                            Pickup
                            {{ current_hotel.settings.pickup_spots[group] }}
                          </template>
                          <template v-else>
                            {{ $t(group) }}
                          </template>
                        </span>
                      </div>
                    </template>
                  </div>
                </template>
              </th>
            </tr>
            <tr class="header-row">
              <th
                v-for="column_header in column_headers"
                :key="`${column_header.group}-${column_header.column}`"
                :class="getClassHeaderRowTh(column_header)"
              >
                <div :class="getClassHeaderRowCell(column_header)">
                  <!-- <span
                    class="d-block day-name grey--text text--darken-3 text-uppercase text-truncate"
                  >
                    <template v-if="column_header.group === 'segment'">
                      {{ getSegmentName(column_header) }}
                    </template>
                    <template v-else-if="column_header.group === 'roomtype'">
                      <div
                        class="d-flex align-center justify-center"
                        style="gap: 5px"
                      >
                        <span class="text-truncate">
                          {{ getRoomTypeName(column_header) }}
                        </span>
                        <v-avatar size="18" color="grey lighten-2">
                          {{ getRoomTypeAvailableRooms(column_header) }}
                        </v-avatar>
                      </div>
                    </template>
                    <template v-else>
                      {{ $t(column_header.column) }}
                    </template>
                  </span> -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        class="d-block day-name grey--text text--darken-3 text-uppercase text-truncate"
                      >
                        <template v-if="column_header.group === 'segment'">
                          {{ getSegmentName(column_header) }}
                        </template>
                        <template
                          v-else-if="column_header.group === 'roomtype'"
                        >
                          <div
                            class="d-flex align-center justify-center"
                            style="gap: 5px"
                          >
                            <span class="text-truncate">
                              {{ getRoomTypeName(column_header) }}
                            </span>
                            <v-avatar size="18" color="grey lighten-2">
                              {{ getRoomTypeAvailableRooms(column_header) }}
                            </v-avatar>
                          </div>
                        </template>
                        <template v-else>
                          {{ $t(column_header.column) }}
                        </template>
                      </span>
                    </template>
                    <span>
                      {{ getColumnTitle(column_header) }}
                    </span>
                  </v-tooltip>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <aRmsStrategyDayTableRow
              v-for="day in days"
              :key="`${day}`"
              class="row-data"
              :date="day"
              :row="columns[day]"
              :nonStickyColumnHeaders="non_sticky_column_headers"
              :lastStickyColumn="last_sticky_column"
              :configStrategyTable="configStrategyTable"
              :lastColumnOfEachGroup="last_column_of_each_group"
              @clickOnDateCell="getDayDetails(day)"
              @hoveredKpi="kpi_hover = $event"
            />
            <aRmsStrategyDayTableRow
              class="row-data summary"
              :date="null"
              :row="totalPeriod"
              :nonStickyColumnHeaders="non_sticky_column_headers"
              :lastStickyColumn="last_sticky_column"
              :configStrategyTable="configStrategyTable"
              :lastColumnOfEachGroup="last_column_of_each_group"
              isSummary
              @hoveredKpi="kpi_hover = $event"
            />
          </tbody>
        </table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import aRmsStrategyDayTableRow from "@/components/rms/default/aRmsStrategyDayTableRow.vue";
import { getFriendlyMonthStrategy, showError } from "@/utils.js";
import Vue from "vue";
import { mapGetters } from "vuex";

let default_sticky_group_columns = [""];

export default {
  name: "a-rms-strategy-day-table",
  components: { aRmsStrategyDayTableRow },
  props: {
    configStrategyTable: Object,
    columns: Object,
    totalPeriod: Object,
    days: Array,
    roomTypes: Array,
    segments: Array,
    kpiMode: String
  },
  emits: ["getDayDetails"],
  data: () => ({
    table_class: "rms-strategy-day-table",
    filtered_rows: [],
    filtered_columns: [],
    kpi_hover: ""
  }),
  methods: {
    getDayDetails(v) {
      this.$emit("getDayDetails", v);
    },
    getFriendlyMonthStrategy(date) {
      return getFriendlyMonthStrategy(date, true);
    },
    getHotelComparativeDates() {
      const startDate = Vue.moment(this.days[0]);
      const endDate = Vue.moment(this.days[this.days.length - 1]);

      this.$store
        .dispatch("getHotelComparativeDates", {
          hotel_id: this.current_hotel.id,
          year: startDate.format("YYYY"),
          from_date: startDate.format("YYYY-MM-DD"),
          to_date: endDate.format("YYYY-MM-DD")
        })
        .catch(() => {
          showError(this, "something_went_wrong");
        });
    },
    // Funciones para las clases, para tener el codigo mas limpio --------------------------------------------------
    getClassGroupRowTh(group) {
      let classes = [];
      if (group === this.last_sticky_group_column) {
        classes.push("sticky-columns-shadow");
      }
      if (group !== this.last_sticky_group_column) {
        classes.push("br-bolder");
      }
      return classes;
    },
    getClassHeaderRowTh(column_header) {
      let classes = [];
      if (column_header.group === this.last_sticky_group_column) {
        classes.push("sticky-columns-shadow");
      }
      if (
        this.last_column_of_each_group[column_header.group] ===
          column_header.column &&
        column_header.group !== this.last_sticky_group_column
      ) {
        classes.push("br-bolder");
      }
      return classes;
    },
    getClassHeaderRowCell(column_header) {
      let classes = ["cell", "d-flex", "justify-center", "flex-column"];
      if (!this.sticky_columns.includes(column_header.column)) {
        classes.push("kpi-row");
      }
      if (
        this.kpi_hover.column === column_header.column &&
        this.kpi_hover.group === column_header.group
      ) {
        classes.push("kpi-hovered");
      }
      return classes;
    },
    // Funciones para las clases, para tener el codigo mas limpio --------------------------------------------------
    getSegmentName(column_header) {
      return this.segments.find(
        segment => segment.code === column_header.column
      ).name;
    },
    getRoomTypeName(column_header) {
      return this.roomTypes.find(
        roomType => roomType.code === column_header.column
      ).name;
    },
    getRoomTypeAvailableRooms(column_header) {
      return this.roomTypes.find(
        roomType => roomType.code === column_header.column
      ).available_rooms;
    },
    getColumnTitle(column_header) {
      if (column_header.group === "segment") {
        return this.segments.find(
          segment => segment.code === column_header.column
        ).name;
      } else if (column_header.group === "roomtype") {
        return this.roomTypes.find(
          roomType => roomType.code === column_header.column
        ).name;
      } else {
        return this.$t(column_header.column);
      }
    }
  },
  computed: {
    group_names() {
      return this.configStrategyTable && Object.keys(this.configStrategyTable);
    },
    group_of_columns() {
      return (
        (this.configStrategyTable &&
          Object.keys(this.configStrategyTable).reduce((prev, curr) => {
            prev[curr] = Object.keys(this.configStrategyTable[curr].columns);
            return prev;
          }, {})) ||
        undefined
      );
    },
    column_headers() {
      const groups_and_columns = [];
      if (this.group_of_columns) {
        for (const group in this.group_of_columns) {
          this.group_of_columns[group].forEach(column => {
            groups_and_columns.push({ group, column });
          });
        }
      }
      return groups_and_columns;
    },
    last_column_of_each_group() {
      const column_headers = [...this.column_headers].reverse();
      return column_headers.reduce((prev, curr) => {
        if (!prev[curr.group]) {
          prev[curr.group] = curr.column;
        }
        return prev;
      }, {});
    },
    non_sticky_column_headers() {
      return (
        this.column_headers &&
        this.column_headers.filter(
          column =>
            !this.sticky_columns.find(
              sticky_column =>
                column.group === sticky_column.group &&
                column.column === sticky_column.column
            )
        )
      );
    },
    sticky_group_columns() {
      return default_sticky_group_columns;
    },
    last_sticky_group_column() {
      return this.sticky_group_columns[this.sticky_group_columns.length - 1];
    },
    sticky_columns() {
      return (
        this.column_headers &&
        this.column_headers.filter(column =>
          this.group_of_columns[this.last_sticky_group_column].includes(
            column.column
          )
        )
      );
    },
    last_sticky_column() {
      return this.sticky_columns[this.sticky_columns.length - 1];
    },
    non_sticky_group_columns() {
      return this.group_columns.filter(
        group => !this.sticky_group_columns.includes(group)
      );
    },
    // returns an object of year-month: [days]
    unique_years_months() {
      return this.days.reduce((prev, curr) => {
        const year_month = curr
          .split("-")
          .slice(0, 2)
          .join("-");
        if (!prev[year_month]) {
          prev[year_month] = [];
        }
        prev[year_month].push(curr);
        return prev;
      }, {});
    },
    ...mapGetters({
      current_hotel: "current_hotel"
    })
  },
  mounted() {
    this.getHotelComparativeDates();
  }
};
</script>

<style lang="scss" scoped>
.grid-container {
  --heightHeaderRow: 25px;
  --widthColumnDate: 150px;
  --widthColumnColumns: 70px;
  overflow: auto;
  max-width: 100%;
  max-height: calc(100vh - 133px);

  .br-bolder {
    border-right: 1px solid #ccc !important;
    &:last-child {
      border-right: none !important;
    }
  }

  table {
    border-spacing: 0;
    thead {
      position: sticky;
      left: 0;
      top: 0;
      z-index: 3;
      tr {
        th {
          border: none;
          border-left: $borderType $borderColorV;
          height: var(--heightHeaderRow);
          width: var(--widthColumnColumns);
          min-width: var(--widthColumnColumns);
          background: white;
          color: #a0a0a0;
          .cell {
            height: var(--heightHeaderRow);
            font-size: 11px;
            font-weight: 500;
            text-align: center;
            padding: 0 5px;
            width: var(--widthColumnColumns);
            min-width: var(--widthColumnColumns);
            &.kpi-row {
              border-bottom: 2px solid transparent;
              border-top: 2px solid transparent;
            }
            &.kpi-hovered {
              border-bottom-color: #2d6ece;
            }
          }
          &:nth-child(1) {
            position: sticky;
            left: 0;
            width: var(--widthColumnDate);
            min-width: var(--widthColumnDate);
            z-index: 3;
            > .cell {
              width: var(--widthColumnDate);
              min-width: var(--widthColumnDate);
            }
          }
          &.br-bolder + th {
            border-left: none !important;
          }
          &.br-bolder:nth-child(1) {
            border-right-width: 2px !important;
          }
        }
        &.group-row {
          th {
            border-left: none !important;
            &.group-otb {
              position: sticky;
              left: calc(var(--widthColumnDate) + 0px);
              z-index: 3;
            }
          }
        }
        &.header-row {
          box-shadow: 1px 0 0 0 rgba(0, 0, 0, 0.14),
            0 1px 0 0 rgba(0, 0, 0, 0.15), 2px 0 0 0 rgba(0, 0, 0, 0.11),
            0 2px 0 0 rgba(0, 0, 0, 0.12), 4px 0 0 0 rgba(0, 0, 0, 0.07),
            0 4px 0 0 rgba(0, 0, 0, 0.08);
          th {
            &:nth-child(1) {
              border-left: none !important;
              z-index: 4;
            }
          }
        }
      }
    }
    .sticky-columns-shadow {
      box-shadow: 1px 0px 0px 0px rgba(0, 0, 0, 0.15),
        2px 0px 0px 0px rgba(0, 0, 0, 0.12), 4px 0px 0px 0px rgba(0, 0, 0, 0.08);
    }
  }
}
</style>
